import { useState, useEffect } from 'react';
import toast from 'react-hot-toast';
import axios from 'axios';
import { dedupedGet } from '../../lib/requestDedupe';

const usePromotionPacks = () => {
  const [packs, setPacks] = useState([]);
  const [loading, setLoading] = useState(true);
  const [remindersSet, setRemindersSet] = useState(new Set());

  useEffect(() => {
    const fetchPromotionPacks = async () => {
      try {
        const response = await dedupedGet('/api/packs/promotion-packs');
        if (response.data.success) {
          setPacks(response.data.data);
        }
      } catch (error) {
        console.error('Error fetching promotion packs:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchPromotionPacks();
  }, []);

  const setReminder = async (packId, packTitle) => {
    try {
      await axios.post('/api/packs/notify-me', {
        packId,
        packTitle,
      });
      setRemindersSet((prev) => new Set([...prev, packId]));
      toast.success('Reminder set successfully! We will notify you when the test series goes live.', {
        position: 'top-right',
        duration: 3000,
      });
      return true;
    } catch (error) {
      console.error('Error setting reminder:', error);
      toast.error('Failed to set reminder. Please try again.', {
        position: 'top-right',
        duration: 3000,
      });
      return false;
    }
  };

  return {
    packs,
    loading,
    setReminder,
    isReminderSet: (packId) => remindersSet.has(packId),
  };
};

export default usePromotionPacks;
